import IconRender from 'components/common/IconRender'
import { CustomColorsRef, IconSizes } from 'types/general'

interface WizardHeaderProps {
  title: string
  subtitle?: string
  onClose?: () => void
}

const WizardHeader = ({ title, subtitle, onClose }: WizardHeaderProps) => {
  return (
    <div className="bg-imovSecondary w-full h-20 mb-1 mt-[-1px] border-t flex-shrink-0 flex items-center justify-center relative">
      <div className="w-full text-center">
        <h2 className="text-white font-bold text-2xl sm:text-3xl md:text-2xl">
          {title}
        </h2>
        <h3 className="text-white font-thin text-base sm:text-sm md:text-lg">
          {subtitle}
        </h3>
      </div>
      {onClose && (
        <div className="absolute right-2 top-2">
          <button
            type="button"
            onClick={() => onClose()}
            className="text-white font-extrabold text-lg rounded-full h-10 w-10 flex items-center justify-center hover:opacity-80 focus:outline-none transition-opacity"
          >
            <IconRender
              icon="regular-circle-xmark"
              color={CustomColorsRef.White}
              hoverColor={CustomColorsRef.WhiteShadow}
              size={IconSizes.XL}
            />
          </button>
        </div>
      )}
    </div>
  )
}

export default WizardHeader
